import { render } from "./Banner.vue?vue&type=template&id=94c1a104&scoped=true"
import script from "./Banner.vue?vue&type=script&lang=js"
export * from "./Banner.vue?vue&type=script&lang=js"

import "./Banner.vue?vue&type=style&index=0&id=94c1a104&scoped=true&lang=css"

import exportComponent from "/Volumes/DEXP W500C/homePc/актуально/new-dff/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c1a104"]])

export default __exports__